export default __webpack_public_path__ + "static/media/Mario.31d83096.png";